import * as React from "react";

function MentorshipIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={39} height={39} viewBox="0 0 39 39" {...props}>
      <circle cx="19.5" cy="19.5" r="19" fill="#4cd5c5" />
      <path
        d="M26.5 20c0-3.5-3-6.5-6.5-6.5s-6.5 3-6.5 6.5c0 3.5 3 6.5 6.5 6.5s6.5-3 6.5-6.5z"
        fill="#fff"
      />
      <path
        d="M19.5 25c-1 0-2-.5-2.5-1.5-1-.5-1.5-1.5-1.5-2.5 0-.5 0-1 .5-1.5 1-.5 1.5-.5 2.5 0 .5.5.5 1 .5 1.5 0 1-.5 2-1.5 2.5-.5.5-1.5 1-2.5 1z"
        fill="#fff"
      />
    </svg>
  );
}

export default MentorshipIcon;
